import { Prisma } from "@prisma/client";
import { fileSelectValues } from "./file.types";
import { computablePricingValues } from "./pricing.types";
import { ticketTypeValuesWithCount } from "./tickets.types";

export const editableActivityValues = Prisma.validator<Prisma.ActivityDefaultArgs>()({
  include: {
    schedules: {
      include: {
        timetable: true,
      },
      orderBy: {
        timetable: {
          day: "asc",
        },
      },
    },
    activityArea: true,
    ticketTypes: {
      include: {
        ...ticketTypeValuesWithCount.include,
        tickets: {
          include: {
            user: true,
          },
        },
      },
    },
    activityProgramRequest: true,
    event: {
      select: {
        ticketing: true,
        name: true,
      },
    },
  },
});

export type EditableActivity = Prisma.ActivityGetPayload<typeof editableActivityValues>;

export const simpleActivityValues = Prisma.validator<Prisma.ActivityDefaultArgs>()({
  include: {
    schedules: {
      include: {
        timetable: true,
      },
      orderBy: {
        timetable: {
          day: "asc",
        },
      },
    },
    activityArea: true,
    ticketTypes: {
      include: {
        pricing: computablePricingValues,
        tickets: {
          omit: {
            hmac: true,
          },
        },
        customAppearance: {
          include: {
            picture: true,
          },
        },
        customPdfAppearance: {
          include: {
            backgroundPicture: {
              select: fileSelectValues,
            },
            headerPicture: true,
            textPictures: true,
          },
        },
        templatePdf: true,
        groupLimits: true,
      },
    },
    activityProgramRequest: true,
    event: {
      select: {
        ticketing: true,
        name: true,
      },
    },
  },
});

export type SimpleActivity = Prisma.ActivityGetPayload<typeof simpleActivityValues>;
